import { render, staticRenderFns } from "./b-ticket-payment-summary.vue?vue&type=template&id=16431aa8&scoped=true"
import script from "./b-ticket-payment-summary.vue?vue&type=script&lang=ts"
export * from "./b-ticket-payment-summary.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-payment-summary.vue?vue&type=style&index=0&id=16431aa8&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16431aa8",
  null
  
)

export default component.exports